
import { CtaSection as GenericCtaSection } from "@/components/ui/cta-section";

export const CtaSection = () => {
  return (
    <GenericCtaSection
      title="Ready to strengthen your human firewall?"
      description="Get started with a consultation to discuss how security awareness training can transform your employees into your strongest security asset."
      buttonText="Schedule a Consultation"
      buttonVariant="cta"
      bgColor="gradient"
      textColor="white"
      useContactModal={true}
      modalTitle="Security Awareness Training Consultation"
      modalDescription="Let's discuss how we can help build a security-conscious culture in your organization. Fill out the form below and our experts will contact you to schedule a consultation."
      modalFormId="dfa977cc-c726-4029-89d1-d8f757482a67"
      additionalFields={{ 
        lead_source: "Website",
        lead_interest: "Security Awareness Training",
        service_interest: "Employee Training"
      }}
    />
  );
};
